import { Component } from '@theme/component';

/**
 * Announcement bar with marquee scrolling when content overflows.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} content
 * @property {HTMLElement} clone
 *
 * @extends {Component<Refs>}
 */
export class AnnouncementBarMarquee extends Component {
  #resizeObserver = null;

  connectedCallback() {
    super.connectedCallback();
    this.#checkOverflow();

    this.#resizeObserver = new ResizeObserver(() => this.#checkOverflow());
    this.#resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;
  }

  #checkOverflow() {
    const content = this.refs.content;
    if (!content) return;

    const contentWidth = content.scrollWidth;
    const containerWidth = this.offsetWidth;
    const isOverflowing = contentWidth > containerWidth;

    this.dataset.marquee = String(isOverflowing);

    if (isOverflowing) {
      const speed = 50; // px per second
      const duration = contentWidth / speed;
      this.style.setProperty('--marquee-duration', `${duration}s`);
    }
  }
}

if (!customElements.get('announcement-bar-marquee')) {
  customElements.define('announcement-bar-marquee', AnnouncementBarMarquee);
}
